import React from "react";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import { useTranslation } from "react-i18next";
import { Checkboxes } from '../../../FlowConfigurationInputs';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';

export default function SaveAttachments({
  action,
  variables,
  setOpenVariable,
}) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.EMAIL.SAVE-ATTACHMENTS.";
  const options = {
    checkboxes: { label: label + 'OVERWRITE-FILE' }
  }

  return (
    <div>
      <div className="form-element">
        {t(label + 'ATTACHMENTS')}
        <TextInput action={action} inputName="attachments" variables={variables} setOpenVariable={setOpenVariable} isRequired />
      </div>
      <div className="form-element">
        {t(label + "SAVE-ATTACHMENTS-TO-FOLDER")}
        <TextInput
          action={action}
          inputName="path"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={true}
        />
      </div>
      <div className="form-element">
        <Checkboxes action={action} inputName="overwrite" options={options.checkboxes} />
      </div>
      <div className="form-element">
        {t(label + 'ASSIGN-PATH')}
        <VariablePicker action={action} inputName="filePaths" variables={variables}
          setOpenVariable={setOpenVariable} filter="array" isRequired />
        <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'array' })}</em></small>
      </div>
    </div>
  );
}
